export class DeliveryModeModel {
    public code: DeliveryModeCodes;
}

export enum DeliveryModeCodes {
    Default = 'default',
    NonMainland = 'nonMainland'
}